<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="page-container page-view-online">
    <div class="row no-gutters w-100">
      <div class="col-12 col-md-2 col-lg-2 sidebar-wrapper">
        <app-tree-liveview
          #cameraTree
          (onPlay)="liveView($event)"
          (onClear)="resetListPlaying()"
        >
        </app-tree-liveview>
      </div>
      <div class="col-12 col-md-10 col-lg-10 content-wrapper">
        <div class="main-content">
          <!-- <app-multiplayertest></app-multiplayertest> -->
          <div class="container container-watch">
            <div class="row py-4 row-control">
              <div class="col-md-4">
                <h1 class="page-title" style="padding-top: 0.5rem !important">
                  {{ "ad_online" | translate }}
                </h1>
              </div>
              <div class="col-md-4 text-center">
                <ul class="nav nav-tabs tab-views">
                  <li class="nav-item" *ngFor="let grid of grids">
                    <a
                      class="nav-link"
                      [ngStyle]="{
                        'background-image':
                          'url(ic-grid-' +
                          grid.size +
                          (currentGrid === grid.size ? '-w' : '') +
                          '.svg)'
                      }"
                      [ngClass]="{ active: currentGrid === grid.size }"
                      (click)="changeGrid(grid.size)"
                      href="javascript:;"
                    >
                      {{ grid.label }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-md-4 text-right">
                <a
                  *ngIf="listCameraPlaying?.length > 0"
                  class="view-fullscreen fullscreen-toggle enter"
                  (click)="openFullscreen()"
                >
                  <i class="icon icon-fullscreen"></i>
                  <span>{{ "ad_fullscreen" | translate }}</span>
                </a>
                <a
                  class="close-all mr-3"
                  *ngIf="listCameraPlaying?.length > 0"
                  (click)="removeAllVideos()"
                >
                  <i class="icon icon-close-gray"></i>
                  <span>{{ "ad_closeall" | translate }}</span>
                </a>
              </div>
            </div>

            <div class="tab-content">
              <div class="tab-pane active" id="grid-view" role="tabpanel">
                <div [ngClass]="['camera-grid', gridClass]">
                  <div
                    [id]="'camera_' + camera.id"
                    *ngFor="
                      let camera of listCameraPlaying;
                      let i = index;
                      trackBy: cameraTrackById
                    "
                    class="camera-view"
                    style="padding-bottom: unset"
                  >
                    <div class="camera-name">
                      <h4>{{ camera.name }}</h4>
                    </div>
                    <ng-container
                      *ngIf="camera.liveProtocol === 'RTC'; else hlsPlayer"
                    >
                      <app-webrtcplayer
                        [camera]="camera"
                        #webrtc
                      ></app-webrtcplayer>
                      <div class="action">
                        <a
                          (click)="SnapshotCamera(webrtc)"
                          title="{{ 'ad_snapshot' | translate }}"
                          ><i class="icon icon-view-fit"></i
                        ></a>
                        <a (click)="ReloadCamera(webrtc)" title="Reload"
                          ><i class="icon icon-reload"></i
                        ></a>
                        <a
                          (click)="fullScreenCamera(webrtc)"
                          title="{{ 'ad_fullscreen' | translate }}"
                        >
                          <i class="icon icon-view-fullscreen"></i>
                        </a>
                      </div>
                      <a
                        class="view-closecam"
                        title="{{ 'ad_close' | translate }}"
                        (click)="removeCamera(webrtc)"
                      >
                        <i class="icon icon-view-closecam"></i>
                      </a>
                    </ng-container>
                    <ng-template #hlsPlayer>
                      <app-hlsjs
                        #videohls
                        [camera]="camera"
                        [type]="'LIVE_VIEW'"
                        [index]="i"
                        class="camera-media"
                      ></app-hlsjs>
                      <div class="action">
                        <a
                          href="javascript:;"
                          title="Phóng to"
                          (click)="setZoomIn(videohls)"
                          style="margin-right: 3px"
                          ><i class="icon icon-view-zoomin"></i
                        ></a>
                        <a
                          href="javascript:;"
                          title="Thu nhỏ"
                          (click)="setZoomOut(videohls)"
                          ><i class="icon icon-view-zoomout"></i
                        ></a>
                        <a
                          href="javascript:;"
                          (click)="Snapshot(videohls)"
                          title="{{ 'ad_snapshot' | translate }}"
                          ><i class="icon icon-snapshot"></i
                        ></a>
                        <a
                          href="javascript:;"
                          title="{{ 'ad_fullscreen' | translate }}"
                        >
                          <i
                            class="icon"
                            [ngClass]="{
                              'icon-view-fullscreen':
                                fullscreenCameraId !== camera.id,
                              'icon-view-smallscreen':
                                fullscreenCameraId === camera.id
                            }"
                            (click)="fullscreen(videohls)"
                          ></i>
                        </a>
                      </div>
                      <a class="view-closecam" title="Close"
                        ><i
                          class="icon icon-view-closecam"
                          href="javascript:;"
                          (click)="removeVideo(videohls)"
                        ></i
                      ></a>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Modal thông báo bảo trì hệ thống-->
<div
  id="mNotifiInfo"
  class="modal fade bd-example-modal-lg"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-padding">
      <div class="modal-header">
        <h1
          class="modal-title"
          id="exampleModalLabel"
          style="color: black; font-weight: bold"
          translate
        >
          {{ "ad_NOTIFI_SYSTEM" | translate }}
        </h1>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <i class="icon icon-close-gray"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-12">
          {{ "ad_notifi_first" | translate }}
          <div class="form-group">
            <label class="control-label" for="current-password"
              >{{ "ad_notifi_content" | translate }}
            </label>
            <textarea
              [(ngModel)]="currNotifi.content"
              class="form-control"
              rows="4"
              cols="50"
            ></textarea>
          </div>
        </div>
        <div class="col-12" style="display: inline-flex">
          {{ "ad_notifi_second" | translate }}
        </div>
        <div
          class="col-12"
          style="padding-top: 20px; text-align: center; font-style: italic"
        >
          <input id="cbRemind" type="checkbox" style="cursor: pointer" /><label
            for="cbRemind"
            style="margin-left: 5px; cursor: pointer"
            >{{ "ad_notifi_no_view" | translate }}</label
          >
        </div>
        <div
          class="modal-footer text-center"
          style="display: block; float: right"
        >
          <button type="button" class="btn btn-primary" (click)="CloseNotifi()">
            {{ "ad_close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
